import { Sort } from 'interfaces/config';

const getInitialOnSortBy = (sort: Sort) => {
  if (sort && sort.field && sort.order) return `${sort.field}:${sort.order}`;
  return undefined;
};

export default getInitialOnSortBy;
